import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterSp'
})
export class FilterSpPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    // console.log("search text",searchText);
    if(!items) return [];
    if(!searchText) return items;
searchText = searchText.toLowerCase();

return items.filter( it => {
  // console.log(it);
      return String(it.noSolPed).includes(searchText);
    });
   }

}



// WEBPACK FOOTER //
// ./src/app/pipes/filter-sp.pipe.ts